import { useState } from "react";
import { ScimSettings } from "./ScimSettings";
import { SsoSettings } from "./SsoSettings";

export function SsoScimSettings() {
  const [ssoEnabled, setSsoEnabled] = useState<boolean | null>(null);
  const [idpProviderHint, setIdpProviderHint] = useState<string | null>(null);

  return (
    <div className="text-foreground">
      <SsoSettings
        onEnabledChange={(enabled, provider) => {
          setSsoEnabled(enabled);
          setIdpProviderHint(provider);
        }}
      />
      {ssoEnabled !== null && (
        <ScimSettings
          ssoEnabled={ssoEnabled}
          idpProviderHint={idpProviderHint}
        />
      )}
    </div>
  );
}
